export default "__VITE_ASSET__3cd83913__"